import { NOTIFICATION_STATUS } from '../../constants';

export default ({ item, palette }) => {
        switch (item.status) {
            case NOTIFICATION_STATUS.ERROR:
                return palette.negativeContent;
            case NOTIFICATION_STATUS.WARNING:
                return palette.cautionContent;
            case NOTIFICATION_STATUS.SUCCESS:
                return palette.positiveContent;
            case NOTIFICATION_STATUS.GENERIC:
                return palette.primaryBackgroundHigh;
            default:
                return palette.primaryBackgroundHigh;
        }
    };